const isSmall = () => window.outerWidth < 768;

const isIE = () => {
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.userAgent.indexOf('Trident/') > -1) {
        return 1;
    }
    return 0;
};

export { isSmall, isIE };
